import React, { useEffect } from 'react'
import HeaderSec from '../../HeaderSec/HeaderSec'
import FooterComp from '../FooterComp'
import FooterSecComp from '../FooterSecComp'
import copyright from '../../../Assets/img/Copyright.png'

const Copyrights = () => {
  useEffect(() => {
          window.scrollTo(0, 0);
      }, []);

    const section1 = ['GuideStar India is an initiative of Civil Society Information Services India, also known as CISIS India, a public charitable trust registered in Delhi, India. The name GuideStar India and all the web domain names associated with it belong to Civil Society Information Services India, also known as CISIS India. The use of “GuideStar India”, its logo and associated web URLs solely belong to Civil Society Information Services India, also known as CISIS India.']

  return (
    <div className='max-w-screen overflow-hidden'>
        <HeaderSec/>
        <div className='max-w-[1200px] m-auto min-h-[500px]'>
            <FooterSecComp
                topic={'COPYRIGHT CSIS INDIA'}
                section={section1}
                image={copyright}
            />
        </div>
        <FooterComp/>
    </div>
  )
}

export default Copyrights